import { Reducer } from "react";
import { Action } from "redux";
import Actions from "../actions";
import { GeneralState } from "./state";
import { NotificationsLoadedAction, SelectedBranchChangedAction, IncomingMessagesSummaryLoadedAction, IncomingMessageReceivedAction, CommunicationMarkedAsReadAction, TasksUpdatedAction, SelectedCashRegisterNameChangedAction, UnreadMessagesMarkedAsReadAction, CommunicationQuotasLoadedAction } from "./types";
import { IncomingMessageNotification } from "../../models";
import Cookies from "js-cookie";

const initialState: GeneralState = {
    notifications: [],
    tasksUpdatedAt: 0,
    messagesMenu: {
        unreadMessages: [],
        recentMessages: [],
    },
}

export const reconsilor = (persisted: GeneralState): GeneralState => ({
    ...initialState,
    selectedCashRegisterName: persisted?.selectedCashRegisterName,
});


export const reducer: Reducer<GeneralState | undefined, Action<Actions>> = (state = initialState, action): GeneralState => {
    switch (action.type) {
        case Actions.LoggedOut:
        case Actions.LoggedIn:
            return initialState;
        case Actions.NotificationsLoaded:
            return handleNotificationsLoaded(state, action as NotificationsLoadedAction);
        case Actions.TasksUpdated:
            return handleTasksUpdated(state, action as TasksUpdatedAction);
        case Actions.SelectedBranchChanged:
            return handleSelectedBranchChanged(state, action as SelectedBranchChangedAction);
        case Actions.IncomingMessagesSummaryLoaded:
            return handleIncomingMessagesSummaryLoaded(state, action as IncomingMessagesSummaryLoadedAction);
        case Actions.IncomingMessageReceived:
            return handleIncomingMessageReceived(state, action as IncomingMessageReceivedAction);
        case Actions.CommunicationMarkedAsRead:
            return handleCommunicationMarkedAsRead(state, action as CommunicationMarkedAsReadAction);
        case Actions.UnreadMessagesMarkedAsRead:
            return handleUnreadMessagesMarkedAsRead(state, action as UnreadMessagesMarkedAsReadAction);
        case Actions.CommunicationQuotasLoaded:
            return {
                ...state,
                communicationQuotas: (action as CommunicationQuotasLoadedAction).payload.communicationQuotas,
                communicationQuotasFetchedAt: (action as CommunicationQuotasLoadedAction).payload.fetchedAt,
            };
        case Actions.SelectedCashRegisterNameChanged:
            return { ...state, selectedCashRegisterName: (action as SelectedCashRegisterNameChangedAction).payload.name };
        default:
            return state;
    }
};

const handleNotificationsLoaded = (state: GeneralState, action: NotificationsLoadedAction): GeneralState => ({
    ...state,
    notifications: action.payload,
});

const handleTasksUpdated = (state: GeneralState, action: TasksUpdatedAction): GeneralState => ({
    ...state,
    tasksUpdatedAt: action.payload.updatedAt,
});

const handleSelectedBranchChanged = (state: GeneralState, action: SelectedBranchChangedAction): GeneralState => {
    Cookies.set('SELECTED_BRANCH', action.payload.branch, {expires: 365})
    return {
        ...state,
        branchSelected: action.payload.branch,
    }
}

const handleIncomingMessagesSummaryLoaded = (state: GeneralState, action: IncomingMessagesSummaryLoadedAction): GeneralState => ({
    ...state,
    messagesMenu: action.payload,
});

const handleIncomingMessageReceived = (state: GeneralState, action: IncomingMessageReceivedAction): GeneralState => ({
    ...state,
    messagesMenu: {
        unreadMessages: prependUniqueMessage(state.messagesMenu.unreadMessages, action.payload),
        recentMessages: prependUniqueMessage(state.messagesMenu.recentMessages, action.payload, 10),
    },
});

const handleCommunicationMarkedAsRead = (state: GeneralState, action: CommunicationMarkedAsReadAction): GeneralState => ({
    ...state,
    messagesMenu: {
        ...state.messagesMenu,
        unreadMessages: action.payload.read
            ? state.messagesMenu.unreadMessages.filter(msg => msg.id !== action.payload.communicationId)
            : state.messagesMenu.unreadMessages,
    },
});

const handleUnreadMessagesMarkedAsRead = (state: GeneralState, _: UnreadMessagesMarkedAsReadAction): GeneralState => ({
    ...state,
    messagesMenu: {
        ...state.messagesMenu,
        unreadMessages: [],
    },
});

const prependUniqueMessage = (
    messages: IncomingMessageNotification[],
    nextMessage: IncomingMessageNotification,
    limit?: number,
): IncomingMessageNotification[] => {
    const updatedMessages = [nextMessage, ...messages.filter(message => message.id !== nextMessage.id)];
    return typeof limit === 'number' ? updatedMessages.slice(0, limit) : updatedMessages;
};
